export default "__VITE_ASSET__zmvdXGX6__"